import { tick } from 'svelte';
import { get } from 'svelte/store';

import { isJumpOneLink, startTime } from '../stores/index';

import { mediaEventUpOnce, getMediaEvent2006Ext } from './eventUp';
import { getOnelinkUrl } from './onelink';
import { trackEvent } from './track';

import { getH5ocrBaseUrl } from '@/utils/getH5ocrLink';
import url from '@/utils/url';

/** 与 DSL mkt-mx-adv-login-module 一致：landing-page + #/register，并保留现金贷自动进件参数 */
export const getH5CashLoanUrl = (
    params: Record<string, string | number> = {}
) => {
    const baseUrl = getH5ocrBaseUrl();
    const resource = url.get('resource') || window.adv?.getChannelEnv();
    const parseQuery = url.parseQuery();
    const urlQuery = {
        ...parseQuery,
        resource,
        fromPage: 'web-marketing',
        fromPageId: window?.__PAGE_CONFIG__?.trackingPageId || '',
        ...params
    };

    return url.buildUrl(baseUrl, urlQuery);
};

export const JumpLink = async () => {
    try {
        isJumpOneLink.set(true);
        await tick();
        mediaEventUpOnce(2006, getMediaEvent2006Ext());
        const link = getH5CashLoanUrl();
        const preloader = window?.preloader;

        if (
            preloader &&
          preloader.shouldShowIframe &&
          preloader.shouldShowIframe()
        ) {
            if (preloader.showIframe && preloader.showIframe()) {
                console.log('预加载');

                return;
            }
        }

        trackEvent(
            'fin_loan_abroad_external_ad_landing_time_sw',
            {
                stay_time: Date.now() - get(startTime)
            },
            true
        );
        if (link) {
            console.log('跳转');
            window.location.href = link;
        }
    } catch (error) {
        console.error('JumpLink error:', error);
    }
};

export const jumpToOnelink = async () => {
    isJumpOneLink.set(true);
    await tick();
    mediaEventUpOnce(2006, getMediaEvent2006Ext());
    const linkUrl = getOnelinkUrl();

    if (linkUrl) {
        window.location.href = linkUrl;
    }

    isJumpOneLink.set(false);
};
